import { useEffect, useState } from "react";

import { seatConfigurationService } from "@/features/administration/seat-configuration/seat-configuration.service";
import { storageService } from "@/features/storage/storage.service";

export const useStorageSubscription = () => {
    const [updateTrigger, setUpdateTrigger] = useState(0);

    useEffect(() => {
        const unsubscribeStorage = storageService.subscribe(() => {
            setUpdateTrigger((prev) => prev + 1);
        });
        const unsubscribeSeatConfig = seatConfigurationService.subscribe(() => {
            setUpdateTrigger((prev) => prev + 1);
        });

        return () => {
            unsubscribeStorage();
            unsubscribeSeatConfig();
        };
    }, []);

    return updateTrigger;
};
